import { HttpErrorResponse } from '@angular/common/http';

export function extractMessage(err: HttpErrorResponse): string {
  if (err.error && typeof err.error === 'object' && typeof err.error.message === 'string') {
    return err.error.message;
  }
  if (typeof err.error === 'string' && err.error) {
    return err.error;
  }
  if (err.status > 0) {
    return `${err.status} ${err.statusText || 'Error'}`;
  }
  return 'Could not connect to the server. Please check your network and try again.';
}
